import { render, staticRenderFns } from "./cabecalho-db-piloto.vue?vue&type=template&id=35400afb&scoped=true"
import script from "./cabecalho-db-piloto.vue?vue&type=script&lang=js"
export * from "./cabecalho-db-piloto.vue?vue&type=script&lang=js"
import style0 from "./cabecalho-db-piloto.vue?vue&type=style&index=0&id=35400afb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35400afb",
  null
  
)

export default component.exports